export const uploadFileToOneDrive = async (token: string, foldername: string, filename: string, data: BodyInit) => {
    console.info(`Write file: ${filename} into: ${foldername}`);

    // Check if this is a stub token for development
    if (token.startsWith("stub-server-token-")) {
        console.info("Using mock OneDrive upload for development");

        // Return a mock OneDrive response
        const mockResponse = {
            id: `mock-file-${Date.now()}`,
            name: filename,
            webUrl: `https://graph.microsoft.com/v1.0/me/drive/root:/${foldername}/${filename}`,
            parentReference: {
                path: `/drive/root:/${foldername}`,
            },
            size: data instanceof ArrayBuffer ? data.byteLength : 0,
            createdDateTime: new Date().toISOString(),
            lastModifiedDateTime: new Date().toISOString(),
            file: {
                mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
        };

        return Promise.resolve(mockResponse);
    }

    // Real OneDrive upload for production
    return fetch(`https://graph.microsoft.com/v1.0/me/drive/root:/${foldername}/${filename}:/content`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            authorization: "bearer " + token,
        },
        body: data,
        mode: "cors",
        cache: "default",
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                throw `Error ${response.status}: ${response.statusText} : ${response.body}`;
            }
        })
        .then((drive) => {
            return drive;
        });
};
